__turbopack_context__.v({
  "className": "pacifico_176cdf37-module__vUiAQq__className",
  "variable": "pacifico_176cdf37-module__vUiAQq__variable",
});
